<p-toast [preventOpenDuplicates]="true" [baseZIndex]="10500" [autoZIndex]="false" />
<app-update-notification-banner></app-update-notification-banner>

<section
  [ngClass]="{
    dashboard: true,
    'menu-pinned': isMenuPinned,
  }">
  @if (isSidebarVisible) {
    <app-side-menu></app-side-menu>
  }
  <div
    [ngClass]="{
      'dashboard__main-content': true,
      'px-3': !isMenuPinned,
      'pinned-menu': isMenuPinned,
      'layout-top-menu': isTopMenuLayout,
    }"
    [ngStyle]="{
      width: isMenuPinned
        ? '100%'
        : isMenusOpen
          ? 'calc(100% - ' + (isMobile ? '0' : '275') + 'px)'
          : 'calc(100% - ' + (isMobile ? '0' : '75') + 'px)',
    }">
    <router-outlet></router-outlet>
  </div>
</section>

<!-- Só monta para quem pode abrir. O modal fica no shell, então ele nasce em TODA rota do
     dashboard mesmo fechado — e dois filhos dele (`app-select-company` e, dentro do modal
     de contato, `app-modal-create-simple-account`) carregam dados no `ngOnInit`, não no
     open. Resultado: `GET companys` e `GET financial-institutions` em todo carregamento de
     página, para todo usuário. Quem tem permissão recebe 200 e não percebe; o parceiro
     recebe 403 nos dois e leva o toast "sem permissão" logo depois do login, sem ter feito
     nada. A permissão aqui é a MESMA que já protege o item de menu "Contatos Bancários",
     único gatilho do modal, e o `dashboard.component.ts` abre por `?.open(...)` — não
     renderizar é seguro. -->
<app-modal-bank-contacts
  *appHasPermission="bankContactsPermission"
  #bankContactsDialog></app-modal-bank-contacts>
<app-onboarding-select-company-modal
  #onboardingSelectCompanyDialog></app-onboarding-select-company-modal>
